// Runtime config. Override API_BASE via <meta name="api-base" content="..."> if needed.
function meta(name: string): string | null {
  return document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)?.content ?? null;
}

export const API_BASE = meta("api-base") ?? "http://localhost:8787";
export const PRODUCT = "ShortDrama Admin";
